export function toNullable(value: string | undefined): string | null {
  if (value === null || value === undefined) return null

  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}
